import type { CalendarAttachment } from "openapi/api/model"

export const toCalendarAttachment = async (file: File): Promise<CalendarAttachment> => {
  const contentBase64 = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = reader.result
      if (typeof result !== "string") {
        reject(new Error("Failed to read attachment"))
        return
      }

      const encoded = result.split(",")[1]
      resolve(encoded || "")
    }
    reader.onerror = () => reject(new Error("Failed to read attachment"))
    reader.readAsDataURL(file)
  })

  return {
    filename: file.name,
    contentType: file.type || "application/octet-stream",
    contentBase64,
  }
}

export const toCalendarAttachments = async (files: File[] = []) => {
  if (files.length === 0) return undefined
  return Promise.all(files.map(toCalendarAttachment))
}
